var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVibrationOff = function SvgVibrationOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 8,
    height: 12,
    rx: 1,
    stroke: "#F6650A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4.5,
    width: 3,
    height: 4,
    rx: 0.5,
    stroke: "#F6650A"
  })));
};
export { SvgVibrationOff as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='4' y='2' width='8' height='12' rx='1' stroke='%23F6650A'/%3E %3Crect x='6.5' y='4.5' width='3' height='4' rx='0.5' stroke='%23F6650A'/%3E %3C/svg%3E";